import actionTypes from '../constants/action-types';

const loadMetaTranslations = () => ({
  type: actionTypes.LOAD_META_TRANSLATIONS,
});

export default loadMetaTranslations;
